import React, { useState, useEffect } from 'react';
import { Input, Divider, Space, Spin, Form, Select } from 'antd';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton'
import Pagination from '../../../components/global/pagination/Pagination';
import columns from '../../../columns/cashDeposit/usdConversion/columns';
import { AllCurrency, AllCurrencySync, AddUpdatUpdateCurrencyApi } from '../../../api/request/cashDeposit/usdConversion';
import moment from 'moment/moment';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import LoadableButton from '../../../components/buttons/LoadableButton';

function UsdConversion() {

    const [form] = Form.useForm();
    const userDetails = useSelector((state) => state.user.userDetails);
    let isSalesManager = userDetails?.roleId === 6;

    const [usdValue, setUsdValue] = useState('1');
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [currencyid, setCurrencyid] = useState()
    const [depositData, setDepositData] = useState([]);
    const [withdrawData, setWithdrawData] = useState([]);
    const [depositTotalRecord, setDepositTotalRecord] = useState(0);
    const [withdrawTotalRecord, setWithdrawTotalRecord] = useState(0);

    const fetchCurrencyData = async (filterText) => {
        let params = {
            PageNumber: page,
            PageSize: pageSize,
            FilterText: filterText,
        };
        const { data } = await AllCurrency(new URLSearchParams(params).toString());
        return data;
    };

    const getAllCurrencyDetails = async () => {
        try {
            setIsLoading(true);

            const [depositRes, withdrawRes] = await Promise.all([
                fetchCurrencyData("Deposit"),
                fetchCurrencyData("Withdraw"),
            ]);

            if (depositRes?.success) {
                setDepositData(
                    depositRes?.data?.map((item, index) => ({
                        ...item,
                        id: index,
                        modifiedDate: item?.modifiedDate
                            ? moment(item?.modifiedDate).format("DD-MM-YYYY, hh:mm A")
                            : "--",
                    }))
                );
                setCurrencyid(depositRes?.data[0]?.id);
                setDepositTotalRecord(depositRes?.totalRecords);
            }

            if (withdrawRes?.success) {
                setWithdrawData(
                    withdrawRes?.data?.map((item, index) => ({
                        ...item,
                        id:index,
                        modifiedDate: item?.modifiedDate
                            ? moment(item?.modifiedDate).format("DD-MM-YYYY, hh:mm A")
                            : "--",
                    }))
                );
                setWithdrawTotalRecord(withdrawRes?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };


    const getAllCurrencySync = async () => {
        try {
            const payload = {
                BaseCurrency: "USD",
                TargetCurrency: "INR",
                Amount: 1
            }
            const { data } = await AllCurrencySync(new URLSearchParams(payload).toString());
            if (data?.success) {
                form.setFieldValue('amount', data?.data?.exchangeRate)
            }
        }
        catch (error) { }
    }

    const handleUpdate = async (values) => {
        setIsUpdateLoading(true);
        try {
            const payload = {
                ...values,
                currencyId: currencyid,
            }
            const { data } = await AddUpdatUpdateCurrencyApi(payload);
            if (data?.success) {
                getAllCurrencyDetails();
                form.resetFields();
                toast.success(data?.message);
            }
            setIsUpdateLoading(false);
        }
        catch (error) { setIsUpdateLoading(false) }
    }
    useEffect(() => {
        getAllCurrencyDetails();
    }, [page, pageSize]);
    return (
        <>
            {!isSalesManager && <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full">
                <Form className='w-full' autoComplete="off" form={form} onFinish={handleUpdate}>
                    <div className="px-4 lg:px-6 flex justify-between items-center">
                        <p className="text-[#2F2B3D] text-title font-semibold">INR / USD</p>
                        <div className='flex items-center'>
                            <LoadableButton
                                type='submit'
                                className="flex items-center bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500"
                                lable='Update'
                                loadingLable='Updating'
                                isLoading={isUpdateLoading}
                                disabled={isUpdateLoading}
                            />
                        </div>
                    </div>
                    <Divider />
                    <div className='px-4 lg:px-6 mb-7'>
                        <div className="grid sm:grid-cols-4 lg:grid-cols-4 gap-5">
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">USD</label>
                                <Input disabled defaultValue={usdValue} className="mt-1 w-full ps-4 py-2" prefix={<span>$</span>} />
                            </div>
                            <div className="input-white" >
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">Amount In INR</label>
                                <Form.Item name="amount" rules={[{ required: true, message: 'Please enter amount' }]}>
                                    <Input type='number' placeholder="Amount" className="mt-1 w-full ps-4 py-2" prefix={<span className='text-[#2F2B3DCC]'>₹</span>} />
                                </Form.Item>
                            </div>
                            <div className='ant-select-selector-white'>
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">Currency type</label>
                                <Form.Item name="currencyType" rules={[{ required: true, message: 'Please currency type.' }]}>
                                    <Select size='large' placeholder='Select currency type' className='w-full mt-1 '
                                        options={[{ value: 1, label: 'Deposit' }, { value: 2, label: 'Withdraw' }]}
                                    />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>}
            <div className='grid sm:grid-cols-2 gap-5'>
                <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                    <div className="px-4 lg:px-6 flex flex-col justify-between ">
                        <p className="text-[#2F2B3D] text-title font-semibold">Deposit Update History <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${depositTotalRecord})`}</span></p>
                    </div>
                    <div className="my-6">
                        <TableWithSkeleton columns={columns} data={depositData} loading={isLoading} page={page} pageSize={pageSize} index={true} />
                        <Pagination total={depositTotalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                    </div>
                </div>
                <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                    <div className="px-4 lg:px-6 flex flex-col justify-between">
                        <p className="text-[#2F2B3D] text-title font-semibold">Withdraw Update History <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${withdrawTotalRecord})`}</span></p>
                    </div>
                    <div className="my-6">
                        <TableWithSkeleton columns={columns} data={withdrawData} loading={isLoading} page={page} pageSize={pageSize} index={true} />
                        <Pagination total={withdrawTotalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                    </div>
                </div>
            </div>

        </>
    )
}

export default UsdConversion
